<template>
  <div id="page-orientation-create">
    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between mb-md-4">
      <h5 class="">{{ $t('pages.orientation.createOrientation')}}</h5>
      <div>
        <router-link
            class="btn btn-outline-primary mt-2 mt-md-0"
            :to="{ name: 'orientation-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudOrientation
        :orientation="orientation"
        :actionForm="'create'"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      orientation: {}
    }
  },
  components : {
    FormCrudOrientation: () => import('@/components/pages/orientation/FormCrudOrientation')
  }
}
</script>

<style scoped>

</style>
